import parametersApi from '@/api/parameters';
import { getDecimal } from '@/helpers/numbers';
import { mapGetters } from 'vuex';

const state = {
  parameters: {},
  defaultParameters: [],
  parameter: {},
};

export const getters = {
  calculMin: state => (estimatedHours) => {
    const one = estimatedHours * (state.defaultParameters[1].defaultValue / 100);
    const two = estimatedHours * (state.defaultParameters[2].defaultValue / 100);
    return Math.ceil(getDecimal(estimatedHours) + getDecimal(one) + getDecimal(two));
  },
  calculMax: state => (estimatedHours) => {
    // Calcul 1
    const max = parseInt(estimatedHours) + (parseInt(estimatedHours) * (state.defaultParameters[0].defaultValue / 100));
    // Calcul 2
    const two = ((max * (state.defaultParameters[1].defaultValue / 100))
      + (max * (state.defaultParameters[2].defaultValue / 100)));
    return Math.ceil(getDecimal(max) + getDecimal(two));
  },
  getIndex: state => (name) => {
    const indexObject = state.parameters.find(f =>

      String(f.name).trim() == String(name).trim()
    )
    return indexObject
  }
};

export const actions = {
  init({ dispatch }) {

    dispatch('getList');
  },

  get({ commit }, args) {
    parametersApi.getParameter(args).then((data) => {
      commit('parameter', data.parameter);
    });
  },

  getList({ dispatch }) {
    parametersApi.getDefaultParameters().then((data) => {
      dispatch('setParameters', data);
    });
  },
  //Ajout des champs pour modifier les données directement dans la table
  setParameters({ commit }, args) {
    if (args.defaultParametersList == undefined){
      args.defaultParametersList = args
    }
    let parameters = args.defaultParametersList.map(x => {
      x.disabled = true;
      x.oldValue = {};
      return x;
    })
    commit('parameters', parameters);
    commit('defaultParameters', parameters);
  },
  getDefault({ commit, dispatch }) {
    parametersApi.getDefaultParameters().then((data) => {
      dispatch('setParameters', data.defaultParametersList);
    });
  },
  save({ commit, dispatch }, args) {
    parametersApi.saveParameters(args).then((data) => {
    dispatch('setParameters', data.parameters)

      commit(
        'alert/add',
        {
          title: 'Informations',
          message: 'Les paramètres ont été modifiés avec succès!',
          variant: 'success',
          icon: 'check_circle',
        },
        { root: true },
      );
    });
  },
  search({ commit }, args) {
    parametersApi.searchParameters(args).then((data) => {
      commit('defaultParameters', data.parameters);
    });
  },
};
export const mutations = {
  parameters(state, payload) {
    state.parameters = payload;
  },
  defaultParameters(state, payload) {
    state.defaultParameters = payload;
  },
  parameter(state, payload) {
    state.parameter = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
